// extracted by mini-css-extract-plugin
export default {"disclosureCheckbox":"styles_disclosureCheckbox__-Ymzw","disclosureLabel":"styles_disclosureLabel__3mRfA"};